// import morphElements from  './morph'

export default function eventStarter(): void {
  document.addEventListener('DOMContentLoaded', () => {
    // morphElements()
  })
}
